export const urlStepNames = ["select-editions", "personalization", "distribution", "payment"];
